import { render, staticRenderFns } from "./CreativeReviewerSidebar.vue?vue&type=template&id=385343eb&"
import script from "./CreativeReviewerSidebar.vue?vue&type=script&lang=js&"
export * from "./CreativeReviewerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports